import React from 'react';
import PropTypes from 'prop-types';

import {Translate, translate} from 'views/module';

import Pill from './Pill';

const CallStatusPill = (props) => {
  const {callStatus} = props;

  const statusData = translate(`loomLead.CallStatus.${callStatus}`);

  return (
    <Pill
      backgroundColor={statusData.Color || 'transparent'}
      borderColor={statusData.ColorBorder || statusData.Color || 'transparent'}
      label={<Translate expression={`loomLead.CallStatus.${callStatus}.Title`} />}
      textColor={statusData.ColorText || '#000000'}
    />
  );
};

CallStatusPill.propTypes = {
  callStatus: PropTypes.string.isRequired,
};

export default CallStatusPill;
